import Login from "components/userAccount/loginPage";
import React from "react";
import Layout from "components/layout";

function index() {
  return (
    <Layout>
      <Login />
    </Layout>
  );
}

export default index;
